document.addEventListener("DOMContentLoaded", function() {

	(function () {
		let el = document.querySelector('li a[href="#ulice"]');
		if(typeof(el) === 'undefined' || el === null)
			return;

		el.addEventListener("click", function () {
			setTimeout(function() {
				let streetViewIframe = document.querySelector('#streetViewIframe');
				streetViewIframe.setAttribute('src', streetViewIframe.src);
			}, 1)
		});
	})();

	(function () {
		let el = document.querySelector('.JS-facebook');
		if(typeof(el) === 'undefined' || el === null)
			return;

		el.addEventListener("click", function () {
			window.open(this.href,'title', 'width=783,height=268,top=300,left=650');
			return false;
		});
	})();

	// potlačení funkce CTRL+P
	document.addEventListener('keydown', function(e) {
		if(e.ctrlKey && e.keyCode === 80) {
			e.preventDefault();

			let el = document.querySelector('.JS-facebook');
			if(typeof(el) !== 'undefined' && el !== null)
				el.dispatchEvent(new Event('click'));

			return false;
		}
	});
});